import * as React from 'react';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import DisplayDate from '../../components/DisplayDate';

// TYPES
import { StaffDashboardStaffMember } from '../../api/models';

interface RoleListItemTypes {
	people: StaffDashboardStaffMember;
	isPastProfile?: boolean;
	setReinstateStaffId?: React.Dispatch<React.SetStateAction<string>>;
	setShowReinstateStaffModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RoleListItem: React.FC<RoleListItemTypes> = ({
	people,
	isPastProfile,
	setReinstateStaffId,
	setShowReinstateStaffModal
}) => {
	const staffTypes = useAppSelector((state) => state.lists.staffTypes);
	const userIsAdmin = useAppSelector((state) => state.user.isOrganisationAdmin);

	const { profileImage, firstName, lastName, isYou, staffType, id, needsAttention } = people;

	const staffTypesLookup =
		staffTypes?.reduce<Record<string, string>>((acc, type) => {
			if (type.value) {
				acc[type.value] = type.label || '';
			}
			return acc;
		}, {}) || {};

	return (
		<div className="row-container" key={id || '' + firstName + lastName + staffType}>
			<div className="row detail-row">
				<div className="col-auto pdl-0 pdr-0">
					<CircleImage
						src={profileImage}
						size={40}
						firstName={firstName}
						lastName={lastName}
						isColorBorder={true}
						isProfileInComplete={needsAttention}
					/>
				</div>

				<div className="col-md-auto full-width">
					<div className="row detail-info">
						<div className="col-lg-3 detail-name">
							{firstName} {lastName} {isYou && <strong>(You)</strong>}
						</div>

						<div className="col-lg-3 detail-status">
							<div className="status">{staffTypesLookup[staffType || ''] || staffType}</div>
						</div>

						{!people.isCurrentStaff && people.leftDate ? (
							<div className="col-lg-6">
								<div className="row">
									<div className="col-lg-6 pl-0">
										<span className="body-small text-grey-4 fw-bold mr-1">Start</span>

										<span className="fw-medium">
											<DisplayDate>{people?.joinedDate}</DisplayDate>
										</span>
									</div>

									<div className="col-6 pl-0">
										<span className="body-small text-grey-4 fw-bold mr-1">End</span>

										<span className="fw-medium">
											<DisplayDate>{people?.leftDate}</DisplayDate>
										</span>
									</div>
								</div>
							</div>
						) : null}
					</div>
				</div>

				{isYou ? (
					<div className="col-auto pdr-0 link-group">
						<Link className="btn-text pdr-0" to={`/staff/${id}`}>
							Edit
						</Link>
					</div>
				) : (
					<>
						{userIsAdmin && isPastProfile && (
							<div className="col-auto pdr-0 link-group">
								<Button
									type="button"
									className="btn-text dark-text"
									onClick={() => {
										setReinstateStaffId?.(id || '');
										setShowReinstateStaffModal?.(true);
									}}
								>
									Reinstate
								</Button>
							</div>
						)}

						{userIsAdmin && (
							<div className="col-auto pdr-0 link-group">
								<Link className="btn-text pdr-0" to={`/${isPastProfile ? 'past-staff' : 'staff'}/${id}`}>
									View
								</Link>
							</div>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default RoleListItem;
